// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__jCo8K","select":"styles_select__WxXlg","tab":"styles_tab__QS4ER","active":"styles_active__Hc_a8","disabled":"styles_disabled__FFYHN"};